import debouncedSaveTemplate from "fantastic/lib/debouncedSaveTemplate";
const addRightTableCell = id => (dispatch, getState) => {
  dispatch({ type: "SECTIONS/TABLE_ADD_CELL", payload: { id, dir: "right" } });
  debouncedSaveTemplate(dispatch, getState);
};
const addLeftTableCell = id => (dispatch, getState) => {
  dispatch({ type: "SECTIONS/TABLE_ADD_CELL", payload: { id, dir: "left" } });
  debouncedSaveTemplate(dispatch, getState);
};
const removeTableCell = id => (dispatch, getState) => {
  dispatch({ type: "SECTIONS/TABLE_REMOVE_CELL", payload: { id } });
  debouncedSaveTemplate(dispatch, getState);
};

const addUpTableRow = id => (dispatch, getState) => {
  dispatch({ type: "SECTIONS/TABLE_ADD_ROW", payload: { id, dir: "up" } });
  debouncedSaveTemplate(dispatch, getState);
};
const addDownTableRow = id => (dispatch, getState) => {
  dispatch({ type: "SECTIONS/TABLE_ADD_ROW", payload: { id, dir: "down" } });
  debouncedSaveTemplate(dispatch, getState);
};
const removeTableRow = id => (dispatch, getState) => {
  dispatch({ type: "SECTIONS/TABLE_REMOVE_ROW", payload: { id } });
  debouncedSaveTemplate(dispatch, getState);
};

export default {
  addRightTableCell,
  addLeftTableCell,
  removeTableCell,
  addUpTableRow,
  addDownTableRow,
  removeTableRow
};
